import {
  formatCoinRewardFeedback,
  type CoinRewardFeedbackListener,
  type CoinRewardFeedbackRuntime,
  type CoinRewardFeedbackSnapshot,
} from "../application/coin-reward-feedback";

type FeedbackSource = Pick<
  CoinRewardFeedbackRuntime,
  "getSnapshot" | "subscribe"
>;

const requireElement = (documentScope: Document): HTMLElement => {
  const element = documentScope.getElementById("coin-reward-feedback");
  if (element === null) {
    throw new Error("Missing coin reward feedback element");
  }
  return element;
};

export class CoinRewardFeedbackShell {
  private readonly unsubscribe: () => void;

  public constructor(
    source: FeedbackSource,
    private readonly element: HTMLElement,
  ) {
    const listener: CoinRewardFeedbackListener = (snapshot) => {
      this.render(snapshot);
    };
    this.unsubscribe = source.subscribe(listener);
  }

  public destroy(): void {
    this.unsubscribe();
    this.element.textContent = "";
  }

  private render(snapshot: CoinRewardFeedbackSnapshot): void {
    this.element.textContent =
      snapshot.feedback === null
        ? ""
        : formatCoinRewardFeedback(snapshot.feedback);
  }
}

export const installCoinRewardFeedback = (
  documentScope: Document,
  source: FeedbackSource,
): CoinRewardFeedbackShell =>
  new CoinRewardFeedbackShell(source, requireElement(documentScope));
